/* @flow weak */

import React from "react";

import createReactClass from "create-react-class";
import Reflux from "reflux";
import { getIntlMixinForPhraseProject } from "../i18n/IntlRootMixin";

import { Store } from "./Store";

const stores: { [name: string]: any } = {};

export const registerStore = function (name: string, store: Store) {
    stores[name] = store;
};

const actions: { [name: string]: any } = {};

export const registerActions = function (name: string, actionObject: any) {
    actions[name] = actionObject;
};

function handleStore(handler: any, store: any, props: any) {
    if (typeof handler === "function") {
        return handler(store, props);
    } else if (Array.isArray(handler) && typeof store.getInitialState === "function") {
        const initialState = store.getInitialState();
        return handler.reduce((result: any, key: string) => {
            if (key in initialState) {
                result[key] = initialState[key];
            }
            return result;
        }, {});
    } else {
        return {};
    }
}

function handleActions(handler: any, actionObject: any) {
    if (Array.isArray(handler)) {
        return handler.reduce((result: any, key: string) => {
            if (key in actionObject) {
                result[key] = actionObject[key];
            }
            return result;
        }, {});
    } else {
        return {};
    }
}

function checkSpec(spec: any) {
    const errors = [];

    const knownOptions = ["stores", "actions"];
    const unknownOptions = Object.keys(spec).filter(key => !knownOptions.includes(key));
    if (unknownOptions.length > 0) {
        errors.push(`unknown options: ${unknownOptions.join(", ")}`);
    }

    (spec.stores || []).forEach(([store, handler]: [any, any]) => {
        if (!store || !(store instanceof Store || typeof store.listen === "function")) {
            errors.push(`not a store: ${store}`);
        }
        if (typeof handler !== "function" && !Array.isArray(handler)) {
            errors.push(`bad handler: ${handler}`);
        }
    });

    (spec.actions || []).forEach(([actions, handler]: [any, any]) => {
        if (!actions) {
            errors.push(`actions null: ${actions}`);
        }
        if (!Array.isArray(handler)) {
            errors.push(`bad actions handler: ${handler}`);
        }
    });

    if (errors.length > 0) {
        console.log("Bad connect spec:", errors);
        throw new Error("Bad connect spec: " + errors.join("\n"));
    }
}

type Spec<Props> = {
    stores?: Array<[Store, ((store: any, props: Props) => Partial<Props>) | string[]]>;
    actions?: Array<[any, any]>;
};

export const connect = function <Props, T>(
    spec: Spec<Props>,
    Component: (React.ComponentClass<Props> | React.FunctionComponent<Props>) & T,
    addIntlRoot?: boolean,
    overrideDisplayName?: string
): React.ComponentType<Partial<Props>> & { WrappedComponent: T } {
    checkSpec(spec);

    const displayName = Component.displayName || (typeof Component === "function" ? Component.name : "");
    const addedMixins = [Reflux.ListenerMixin] as React.Mixin<unknown, any>[];
    if (addIntlRoot) {
        // TODO: should be generalized
        addedMixins.push(getIntlMixinForPhraseProject("EXPLORE"));
    }

    const Wrapper = createReactClass({
        mixins: addedMixins,

        displayName: overrideDisplayName ?? displayName + "Wrapper",

        componentWillMount() {
            (spec.stores || []).forEach(([store]) => {
                this.listenTo(store, () => {
                    // We just get the data directly from the stores without
                    // saving it in state, so here we just do a forceUpdate. If
                    // we want to do something more advanced here, it would be
                    // easy to switch though.
                    this.forceUpdate();
                });
            });
        },

        render() {
            let props = { ...this.props };

            props = (spec.stores ?? []).reduce(
                (result, [store, handler]) => {
                    const handlerResult = handleStore(handler, store, this.props);
                    return { ...result, ...handlerResult };
                },
                props
            );

            props = (spec.actions ?? []).reduce(
                (result, [actions, handler]) => {
                    const handlerResult = handleActions(handler, actions);
                    return { ...result, ...handlerResult };
                },
                props
            );
            return React.createElement(Component as any, props);
        }
    });

    (Wrapper as any).WrappedComponent = Component;
    return Wrapper as any;
};
